import { FC, useState } from "react";
import { GeneralButton } from "./GeneralButton";
import { FilterAlt } from "@mui/icons-material";
import { Box, Checkbox, Divider, ListItemText, ListSubheader, Menu, MenuItem } from "@mui/material";
import { useTranslation } from "react-i18next";
import { LookupResponse } from "../../types/employeePageFilters";

interface Props {
  label: string;
  options: LookupResponse[];
  selectedIds: string[];
  onToggle: (id: string) => void;
  onReset: () => void;
}

export const FilterButtonDropDown: FC<Props> = ({ label, options, selectedIds, onToggle, onReset }) => {
  const { t } = useTranslation();
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  const isOpen = Boolean(anchor);

  return (
    <div>
      <GeneralButton
        appVariant="outlined"
        onClick={(e) => setAnchor(isOpen ? null : e.currentTarget)}
        sx={{ textTransform: 'none', whiteSpace: 'nowrap', height: "55px" }}
      >
        <FilterAlt sx={{paddingRight: "5px"}}/>
        {label}
        <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
        <Box sx={{ bgcolor: 'primary.main', color: 'white', width: '24px', borderRadius: '6px', textAlign: 'center', fontSize: '0.75rem' }}>
          {selectedIds.length}
        </Box>
      </GeneralButton>
      <Menu
        anchorEl={anchor}
        open={isOpen}
        onClose={() => setAnchor(null)}
        slotProps={{ paper: { sx: { maxHeight: 300 } } }}
      >
        {options.map((option) => (
          <MenuItem key={option.id} onClick={() => onToggle(option.id)}>
            <Checkbox checked={selectedIds.includes(option.id)} />
            <ListItemText primary={option.name} />
          </MenuItem>
        ))}
        <ListSubheader
          onMouseDown={(e) => e.preventDefault()}
          onClick={onReset}
          sx={{
            position: 'sticky',
            bottom: 0,
            bgcolor: 'background.paper',
            borderTop: '1px solid',
            borderColor: 'divider',
            cursor: 'pointer',
            color: 'red',
            textAlign: 'center',
            lineHeight: '36px',
            '&:hover': { bgcolor: 'action.hover' },
          }}
        >
          {t("buttons.reset")}
        </ListSubheader>
      </Menu>
    </div>
  );
};
